module.exports = __webpack_public_path__ + "assets/img/7a1f5a1258cb06804792feb5f6b95160.svg";